import { generatePath } from "react-router-dom";
import { routes } from "src/shared/constants/routes.constants";
import { useAuth } from "src/shared/lib/rback/AuthContext";

export function usePartnerTabs({ partnerId }: { partnerId: string }) {
  const { hasPermission } = useAuth();

  const tabs = [
    {
      label: "Компания",
      to: generatePath(routes.partnerItem, {
        partner_id: partnerId,
      }),
    },
    {
      label: "Договоры и доп. соглашения",
      to: generatePath(routes.partnerContractsList, {
        partner_id: partnerId,
      }),
      requiredPermissions: "partners.contract.edit",
    },
  ];

  return tabs.filter((tab) => {
    if (!tab.requiredPermissions) return true;

    return hasPermission(tab.requiredPermissions);
  });
}
